import React, { useEffect, useMemo, useState } from 'react';
import { ReactComponent as CalloutDirectionSetterLeft } from 'icons/callouts-direction-setter-left.svg';
import { ReactComponent as CalloutDrodownArrow } from 'icons/callouts-dropdown-arrow.svg';
import { ReactComponent as Error } from 'icons/error.svg';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import {
  ANNOTATION_POSITIONS,
  ANNOTATION_POSITION_TYPES,
  RESET_ANNOTATION_OPTION,
} from 'constants/feature/annotation-elements-constants';
import IconDropDown from 'components/common/icon-dropdown';
import ResetAnnotationPosition from './statement-annotations-position-reset-modal';
import { resetCalloutPositions } from 'api/element-api';
import statusCodes from 'http-status-codes';

export const STATEMENT_ANNOTATIONS_UPDATE_BLOCK =
  'statement-annotations-update-block';
const ANNOTATION_SUMMARY_ICON_SIZE = '30px';
const STATEMENT_ANNOTATIONS_UPDATE_BLOCK_ID =
  'statement-annotations-update-block-id';
const CALLOUT_DROP_DOWN_ARROW_WIDTH = 15;
const CALLOUT_DROP_DOWN_ARROW_HEIGHT = 30;
const TOAST_ERROR_ICON_SIZE = 25;

const StatementAnnotationsUpdate = ({
  resetCalloutPositionsInsideElementCache,
  setAnnotationsDisplayPosition,
  annotationDisplayPosition,
  sectionsInView,
  revisionId,
  disabled,
  isOCR,
}) => {
  const [showModal, setShowModal] = useState(false);

  const resetDraggedAnnotationPosition = async () => {
    try {
      const response = await resetCalloutPositions(revisionId);
      if (response.status === statusCodes.OK) {
        const loadedSectionsInView = Object.keys(sectionsInView);
        resetCalloutPositionsInsideElementCache(loadedSectionsInView);
      }
      setShowModal(false);
    } catch (error) {
      setShowModal(false);
      toast.error(
        <div className={`${STATEMENT_ANNOTATIONS_UPDATE_BLOCK}__toast-error`}>
          <div>
            <Error
              name={'error'}
              width={TOAST_ERROR_ICON_SIZE}
              height={TOAST_ERROR_ICON_SIZE}
            />
          </div>
          <FormattedMessage id="element.callout.position.restore.toast-error-title" />
        </div>,

        { autoClose: 3000 },
      );
    }
  };

  useEffect(() => {
    setAnnotationsDisplayPosition({ position: ANNOTATION_POSITIONS[2] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectAnnotationPosition = (position) => {
    if (position.id === ANNOTATION_POSITION_TYPES.RESET) {
      setShowModal(true);
      return;
    }
    setAnnotationsDisplayPosition({ position });
  };

  const annotationPosition = useMemo(() => {
    return isOCR
      ? ANNOTATION_POSITIONS.concat(RESET_ANNOTATION_OPTION)
      : ANNOTATION_POSITIONS;
  }, [isOCR]);

  return (
    <div className={`${STATEMENT_ANNOTATIONS_UPDATE_BLOCK}`}>
      <div className={`${STATEMENT_ANNOTATIONS_UPDATE_BLOCK}__icons`}>
        <IconDropDown
          displayIconPlaceholder={
            <CalloutDirectionSetterLeft
              width={ANNOTATION_SUMMARY_ICON_SIZE}
              height={ANNOTATION_SUMMARY_ICON_SIZE}
            />
          }
          tooltip={{
            id: STATEMENT_ANNOTATIONS_UPDATE_BLOCK_ID,
            text: disabled
              ? null
              : 'statement-annotations-update-block-tooltip',
            position: 'top',
          }}
          arrowIcon={
            <CalloutDrodownArrow
              width={CALLOUT_DROP_DOWN_ARROW_WIDTH}
              height={CALLOUT_DROP_DOWN_ARROW_HEIGHT}
            />
          }
          options={annotationPosition}
          value={annotationDisplayPosition.annotationPosition}
          onSelectOption={(position) => selectAnnotationPosition(position)}
          disabled={disabled}
        />
      </div>
      {showModal && (
        <ResetAnnotationPosition
          onClose={() => setShowModal(false)}
          onConfirm={() => resetDraggedAnnotationPosition()}
        />
      )}
    </div>
  );
};

export default StatementAnnotationsUpdate;
